import { render, staticRenderFns } from "./CategoryCalls.vue?vue&type=template&id=ad9facc8&scoped=true&"
import script from "./CategoryCalls.vue?vue&type=script&lang=js&"
export * from "./CategoryCalls.vue?vue&type=script&lang=js&"
import style0 from "./CategoryCalls.vue?vue&type=style&index=0&id=ad9facc8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad9facc8",
  null
  
)

export default component.exports